<div class="h-15rem">
  <!-- Known Bug: TabView does not update ink bar that indicates selected tab. Fixed in primeng 11. https://github.com/primefaces/primeng/issues/10117 -->
  <p-tabView class="cron-editor-container" [(activeIndex)]="activeTab" (onChange)="onTabFocus($event)">
    <!-- Minute -->
    <p-tabPanel class="cron-editor-tab" header="Minutes" *ngIf="!options.hideMinutesTab">
      <div class="cron-editor-tab-content" [formGroup]="minutesForm">
        <div class="cron-editor-tab-content-row">
          Every
          <ng-container *ngTemplateOutlet="timePicker; context: { form: minutesForm, showHours: false }"></ng-container>
        </div>
      </div>
    </p-tabPanel>

    <!-- Hourly -->
    <p-tabPanel class="cron-editor-tab" header="Hourly" *ngIf="!options.hideHourlyTab">
      <div class="cron-editor-tab-content" [formGroup]="hourlyForm">
        <div class="cron-editor-tab-content-row">
          Every
          <ng-container *ngTemplateOutlet="timePicker; context: { form: hourlyForm, showHours: true }"></ng-container>
        </div>
      </div>
    </p-tabPanel>

    <!-- Daily-->
    <p-tabPanel class="cron-editor-tab" header="Daily" *ngIf="!options.hideDailyTab">
      <div class="cron-editor-tab-content" [formGroup]="dailyForm">
        <div class="cron-editor-tab-content-row">
          <p-radioButton name="subTab" formControlName="subTab" value="everyDays"></p-radioButton>
          <div
            class="cron-editor-tab-content-row"
            formGroupName="everyDays"
            (click)="dailyForm.controls.subTab.setValue('everyDays')"
          >
            Every

            <span class="p-float-label">
              <p-dropdown
                formControlName="days"
                [options]="selectOptions.monthDays"
                [styleClass]="'cron-editor-dropdown-days-short'"
                appendTo="body"
              ></p-dropdown>
              <label for="dropdown">Day(s)</label>
            </span>

            at

            <ng-container
              *ngTemplateOutlet="timePicker; context: { form: dailyForm.controls.everyDays, showHours: true }"
            ></ng-container>
          </div>
        </div>

        <div class="cron-editor-tab-content-row" (click)="dailyForm.controls.subTab.setValue('everyWeekDay')">
          <p-radioButton name="subTab" formControlName="subTab" value="everyWeekDay"></p-radioButton>

          Week Day (MON-FRI) at

          <ng-container
            *ngTemplateOutlet="timePicker; context: { form: dailyForm.controls.everyWeekDay, showHours: true }"
          ></ng-container>
        </div>
      </div>
    </p-tabPanel>

    <!-- Weekly-->
    <p-tabPanel class="cron-editor-tab" header="Weekly" *ngIf="!options.hideWeeklyTab">
      <div class="cron-editor-tab-content">
        <div class="cron-editor-tab-content-row">
          Every

          <div [formGroup]="weeklyForm" class="cron-editor-day-selection-container">
            <p-checkbox [binary]="true" formControlName="MON" label="Monday"></p-checkbox>
            <p-checkbox [binary]="true" formControlName="TUE" label="Tuesday"></p-checkbox>
            <p-checkbox [binary]="true" formControlName="WED" label="Wednesday"></p-checkbox>
            <p-checkbox [binary]="true" formControlName="THU" label="Thursday"></p-checkbox>
            <p-checkbox [binary]="true" formControlName="FRI" label="Friday"></p-checkbox>
            <p-checkbox [binary]="true" formControlName="SAT" label="Saturday"></p-checkbox>
            <p-checkbox [binary]="true" formControlName="SUN" label="Sunday"></p-checkbox>
          </div>
        </div>

        <div class="cron-editor-tab-content-row">
          at time

          <ng-container *ngTemplateOutlet="timePicker; context: { form: weeklyForm, showHours: true }"></ng-container>
        </div>
      </div>
    </p-tabPanel>

    <!-- Monthly-->
    <p-tabPanel class="cron-editor-tab" header="Monthly" *ngIf="!options.hideMonthlyTab">
      <div class="cron-editor-tab-content" [formGroup]="monthlyForm">
        <!-- Specific day -->
        <div class="cron-editor-tab-content-row">
          <p-radioButton name="subTab" formControlName="subTab" value="specificDay"></p-radioButton>

          <div
            class="cron-editor-tab-content-row"
            (click)="monthlyForm.controls.subTab.setValue('specificDay')"
            formGroupName="specificDay"
          >
            On the

            <ng-container>
              <span class="p-float-label">
                <p-dropdown
                  formControlName="day"
                  [options]="selectOptions.monthDaysWithLasts"
                  [styleClass]="'cron-editor-dropdown-month-days'"
                  appendTo="body"
                ></p-dropdown>
                <label for="dropdown">Day</label>
              </span>
            </ng-container>

            <!--ng-container *ngIf="options.cronFlavor === 'standard'">
                            <span class="p-float-label">
                                <p-dropdown formControlName="day" [options]="selectOptions.monthDaysWithOutLasts" [styleClass]="'cron-editor-dropdown-month-days'" appendTo="body"></p-dropdown>
                                <label for="dropdown">Day</label>
                            </span>
                        </ng-container-->

            of every

            <span class="p-float-label">
              <p-dropdown
                formControlName="months"
                [options]="selectOptions.months"
                [styleClass]="'cron-editor-dropdown-month'"
                appendTo="body"
              ></p-dropdown>
              <label for="dropdown">Month</label>
            </span>

            at time

            <ng-container
              *ngTemplateOutlet="timePicker; context: { form: monthlyForm.controls.specificDay, showHours: true }"
            ></ng-container>
          </div>
        </div>

        <!-- Specific Week day -->
        <div class="cron-editor-tab-content-row">
          <p-radioButton name="subTab" formControlName="subTab" value="specificWeekDay"></p-radioButton>
          <div
            class="cron-editor-tab-content-row"
            (click)="monthlyForm.controls.subTab.setValue('specificWeekDay')"
            formGroupName="specificWeekDay"
          >
            On the

            <span class="p-float-label">
              <p-dropdown
                formControlName="monthWeek"
                [options]="selectOptions.monthWeeks"
                [styleClass]="'cron-editor-dropdown-week'"
                appendTo="body"
              ></p-dropdown>
              <label for="dropdown">Week</label>
            </span>

            <span class="p-float-label">
              <p-dropdown
                formControlName="day"
                [options]="selectOptions.days"
                [styleClass]="'cron-editor-dropdown-days'"
                appendTo="body"
              ></p-dropdown>
              <label for="dropdown">Day</label>
            </span>

            of every

            <span class="p-float-label">
              <p-dropdown
                formControlName="months"
                [options]="selectOptions.months"
                [styleClass]="'cron-editor-dropdown-month'"
                appendTo="body"
              ></p-dropdown>
              <label for="dropdown">Month</label>
            </span>

            at time

            <ng-container
              *ngTemplateOutlet="timePicker; context: { form: monthlyForm.controls.specificWeekDay, showHours: true }"
            ></ng-container>
          </div>
        </div>
      </div>
    </p-tabPanel>

    <!-- Yearly-->
    <p-tabPanel class="cron-editor-tab" header="Yearly" *ngIf="!options.hideYearlyTab">
      <div class="cron-editor-tab-content" [formGroup]="yearlyForm">
        <div class="cron-editor-tab-content-row">
          <p-radioButton name="subTab" formControlName="subTab" value="specificMonthDay"></p-radioButton>
          <div
            class="cron-editor-tab-content-row"
            (click)="yearlyForm.controls.subTab.setValue('specificMonthDay')"
            formGroupName="specificMonthDay"
          >
            On the

            <span class="p-float-label">
              <p-dropdown
                formControlName="day"
                [options]="selectOptions.monthDaysWithLasts"
                appendTo="body"
              ></p-dropdown>
              <label for="dropdown">Day</label>
            </span>

            <!--span *ngIf="options.cronFlavor === 'standard'" class="p-float-label">
                            <p-dropdown formControlName="day" [options]="selectOptions.monthDaysWithOutLasts" appendTo="body"></p-dropdown>
                            <label for="dropdown">Day</label>
                        </span-->

            of

            <span class="p-float-label">
              <p-dropdown
                formControlName="month"
                [options]="selectOptions.months"
                [styleClass]="'cron-editor-dropdown-month'"
                appendTo="body"
              ></p-dropdown>
              <label for="dropdown">Month</label>
            </span>

            at time

            <ng-container
              *ngTemplateOutlet="timePicker; context: { form: yearlyForm.controls.specificMonthDay, showHours: true }"
            ></ng-container>
          </div>
        </div>

        <div class="cron-editor-tab-content-row">
          <p-radioButton name="subTab" formControlName="subTab" value="specificMonthWeek"></p-radioButton>
          <div
            class="cron-editor-tab-content-row"
            (click)="yearlyForm.controls.subTab.setValue('specificMonthWeek')"
            formGroupName="specificMonthWeek"
          >
            On the

            <span class="p-float-label">
              <p-dropdown
                formControlName="monthWeek"
                [options]="selectOptions.monthWeeks"
                [styleClass]="'cron-editor-dropdown-week'"
                appendTo="body"
              ></p-dropdown>
              <label for="dropdown">Week</label>
            </span>

            <span class="p-float-label">
              <p-dropdown
                formControlName="day"
                [options]="selectOptions.days"
                [styleClass]="'cron-editor-dropdown-days'"
                appendTo="body"
              ></p-dropdown>
              <label for="dropdown">Day</label>
            </span>

            of

            <span class="p-float-label">
              <p-dropdown
                formControlName="month"
                [options]="selectOptions.months"
                [styleClass]="'cron-editor-dropdown-month'"
                appendTo="body"
              ></p-dropdown>
              <label for="dropdown">Month</label>
            </span>

            at time

            <ng-container
              *ngTemplateOutlet="timePicker; context: { form: yearlyForm.controls.specificMonthWeek, showHours: true }"
            ></ng-container>
          </div>
        </div>
      </div>
    </p-tabPanel>

    <!-- Advanced-->
    <p-tabPanel class="cron-editor-tab" header="Advanced" *ngIf="!options.hideAdvancedTab">
      <div class="cron-editor-tab-content" [formGroup]="advancedForm">
        <span class="p-float-label">
          <input pInputText type="text" class="advanced-cron-editor-input" formControlName="expression" />
          <label for="input">Expression</label>
        </span>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>

<ng-template #timePicker let-form="form" let-showHours="showHours">
  <div [formGroup]="form" class="time-picker-container">
    <ng-container *ngIf="showHours">
      <span class="p-float-label">
        <p-dropdown
          inputId="dropdown"
          [options]="selectOptions.hours"
          formControlName="hours"
          [styleClass]="'cron-editor-dropdown-time'"
          appendTo="body"
        ></p-dropdown>
        <label for="dropdown">Hours(s)</label>
      </span>
      <span class="time-picker-separator">:</span>
    </ng-container>

    <span class="p-float-label">
      <p-dropdown
        inputId="dropdown"
        [options]="selectOptions.minutes"
        formControlName="minutes"
        [styleClass]="'cron-editor-dropdown-time'"
        appendTo="body"
      ></p-dropdown>
      <label for="dropdown">Minute(s)</label>
    </span>

    <ng-container *ngIf="!options.hideSeconds">
      <span class="time-picker-separator">:</span>
      <span class="p-float-label">
        <p-dropdown
          inputId="dropdown"
          [options]="selectOptions.seconds"
          formControlName="seconds"
          [styleClass]="'cron-editor-dropdown-time'"
          appendTo="body"
        ></p-dropdown>
        <label for="dropdown">Second(s)</label>
      </span>
    </ng-container>
  </div>
</ng-template>
